// import lib
import validHelper from '../lib/validHelper';
import isEmpty, { isFileEmpty } from '../lib/isEmpty';

export const addAuthorValid = (reqBody) => {
    let validDoc = {
        name: { type: 'string', required: true },
        role: { type: 'string', required: true }
    }

    return validHelper(validDoc, reqBody)
}

export const editAuthorValid = (reqBody) => {
    let validDoc = {
        _id: { type: 'string', required: true },
        name: { type: 'string', required: true },
        role: { type: 'string', required: true }
    }

    return validHelper(validDoc, reqBody)
}

export const addBlogValid = (reqBody) => {

    let validDoc = {
        title: { type: 'string', required: true },
        slug: { type: 'string', required: true },
        authorId: { type: 'string', required: true },
        readDuration: { type: 'number', required: true, min: 1 },
        category: { type: 'string', required: true },
        metaTitle: { type: 'string', required: true },
        metaDescription: { type: 'string', required: true },
        metaKeywords: { type: 'string', required: true },
        content: { type: 'string', required: true },
        blogTitles: { type: 'array', required: true, elementType: 'string' },
        coverImage: { type: 'file', required: true, acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}

export const editBlogValid = (reqBody) => {

    let validDoc = {
        _id: { type: 'string', required: true },
        title: { type: 'string', required: true },
        slug: { type: 'string', required: true },
        authorId: { type: 'string', required: true },
        readDuration: { type: 'number', required: true, min: 1 },
        category: { type: 'string', required: true },
        metaTitle: { type: 'string', required: true },
        metaDescription: { type: 'string', required: true },
        metaKeywords: { type: 'string', required: true },
        content: { type: 'string', required: true },
        blogTitles: { type: 'array', required: true, elementType: 'string' },
        coverImage: { type: 'file', required: (!isEmpty(reqBody?.coverImage) && reqBody?.coverImage instanceof File), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}

export const blogSeoEditValid = (reqBody) => {

    let validDoc = {
        blogId: { type: 'string', required: true },
        schemaMarkup: { type: 'stringify', required: true, elementType: 'object' },
        canonicalUrl: { type: 'url', required: true },
        robotsMetaTag: { type: 'string', required: true },
        ogTitle: { type: 'string', required: true },
        ogDescription: { type: 'string', required: true },
        ogImage: { type: 'file', required: (!isEmpty(reqBody?.ogImage) && reqBody?.ogImage instanceof File), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}

export const addFaqValid = (reqBody) => {
    let validDoc = {
        question: { type: 'string', required: true },
        answer: { type: 'string', required: true }
    }

    return validHelper(validDoc, reqBody)
}

export const editFaqValid = (reqBody) => {
    let validDoc = {
        _id: { type: 'string', required: true },
        question: { type: 'string', required: true },
        answer: { type: 'string', required: true }
    }

    return validHelper(validDoc, reqBody)
}

export const addBlogFaqValid = (reqBody) => {
    let validDoc = {
        blogId: { type: 'string', required: true },
        question: { type: 'string', required: true },
        answer: { type: 'string', required: true }
    }

    return validHelper(validDoc, reqBody)
}

export const editBlogFaqValid = (reqBody) => {
    let validDoc = {
        _id: { type: 'string', required: true },
        blogId: { type: 'string', required: true },
        question: { type: 'string', required: true },
        answer: { type: 'string', required: true }
    }

    return validHelper(validDoc, reqBody)
}

export const addWorkValid = (reqBody) => {
    let validDoc = {
        name: { type: 'string', required: true },
        location: { type: 'string', required: true },
        category: { type: 'string', required: true },
        year: { type: 'number', required: true, min: 1 },
        services: { type: 'string', required: true },
        content: { type: 'string', required: true },
        metaTitle: { type: 'string', required: true },
        metaDescription: { type: 'string', required: true },
        metaKeywords: { type: 'string', required: true },
        coverImage: { type: 'file', required: true, acceptExt: ['jpg', 'jpeg', 'png', 'webp'] },
        midImage: { type: 'file', required: true, acceptExt: ['jpg', 'jpeg', 'png', 'webp'] },
        bottomImages: { type: 'file', required: false },
    }

    return validHelper(validDoc, reqBody)
}

export const editWorkValid = (reqBody) => {
    let validDoc = {
        _id: { type: 'string', required: true },
        name: { type: 'string', required: true },
        location: { type: 'string', required: true },
        category: { type: 'string', required: true },
        year: { type: 'number', required: true, min: 1 },
        services: { type: 'string', required: true },
        content: { type: 'string', required: true },
        metaTitle: { type: 'string', required: true },
        metaDescription: { type: 'string', required: true },
        metaKeywords: { type: 'string', required: true },
        coverImage: { type: 'file', required: (!isEmpty(reqBody?.coverImage) && reqBody?.coverImage instanceof File), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] },
        midImage: { type: 'file', required: (!isEmpty(reqBody?.midImage) && reqBody?.midImage instanceof File), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] },
        bottomImages: { type: 'file', required: false },
    }

    return validHelper(validDoc, reqBody)
}

export const workSeoEditValid = (reqBody) => {

    let validDoc = {
        workId: { type: 'string', required: true },
        schemaMarkup: { type: 'stringify', required: true, elementType: 'object' },
        canonicalUrl: { type: 'url', required: true },
        robotsMetaTag: { type: 'string', required: true },
        ogTitle: { type: 'string', required: true },
        ogDescription: { type: 'string', required: true },
        ogImage: { type: 'file', required: (!isEmpty(reqBody?.ogImage) && reqBody?.ogImage instanceof File), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}

export const addTestimonialValid = (reqBody) => {
    let validDoc = {
        name: { type: 'string', required: true },
        description: { type: 'string', required: true },
        ownerName: { type: 'string', required: true },
        category: { type: 'string', required: true },
        reviewStar: { type: 'number', required: true, min: 1, max: 5 },
        side: { type: 'string', required: true, enum: ['left', 'right'] },
        coverImage: { type: 'file', required: true, acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}

export const editTestimonialValid = (reqBody) => {
    let validDoc = {
        _id: { type: 'string', required: true },
        name: { type: 'string', required: true },
        description: { type: 'string', required: true },
        ownerName: { type: 'string', required: true },
        category: { type: 'string', required: true },
        reviewStar: { type: 'number', required: true, min: 1, max: 5 },
        side: { type: 'string', required: true, enum: ['left', 'right'] },
        coverImage: { type: 'file', required: (!isEmpty(reqBody?.coverImage) && reqBody?.coverImage instanceof File), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}